var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinnings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.052 20.484"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "winnings_svg__Icon_-_Price_Boost",
    "data-name": "Icon - Price Boost",
    transform: "translate(.249 .248)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "winnings_svg__Path_5693",
    "data-name": "Path 5693",
    d: "M31.28 5.007L27.023.75l-4.257 4.257",
    transform: "translate(-7.538 -.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "winnings_svg__Path_5694",
    "data-name": "Path 5694",
    d: "M15.706 8.94h-2.72a1.8 1.8 0 00-.669 3.461l2.761 1.1a1.8 1.8 0 01-.669 3.462h-2.717",
    transform: "translate(-3.706 -2.96)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "winnings_svg__Line_1233",
    "data-name": "Line 1233",
    transform: "translate(9.994 4.308)",
    d: "M0 1.672V0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "winnings_svg__Line_1234",
    "data-name": "Line 1234",
    transform: "translate(9.994 14.007)",
    d: "M0 1.672V0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "winnings_svg__Path_5695",
    "data-name": "Path 5695",
    d: "M10.242.75a9.492 9.492 0 109.492 9.492V.75",
    transform: "translate(-.249 -.248)"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNS4wNTIgMjAuNDg0Ij4KICA8ZyBpZD0iSWNvbl8tX1ByaWNlX0Jvb3N0IiBkYXRhLW5hbWU9Ikljb24gLSBQcmljZSBCb29zdCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4yNDkgMC4yNDgpIj4KICAgIDxwYXRoIGlkPSJQYXRoXzU2OTMiIGRhdGEtbmFtZT0iUGF0aCA1NjkzIiBkPSJNMzEuMjgsNS4wMDcsMjcuMDIzLjc1LDIyLjc2Niw1LjAwNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTcuNTM4IC0wLjI0OCkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgICA8cGF0aCBpZD0iUGF0aF81Njk0IiBkYXRhLW5hbWU9IlBhdGggNTY5NCIgZD0iTTE1LjcwNiw4Ljk0aC0yLjcyYTEuOCwxLjgsMCwwLDAtLjY2OSwzLjQ2MWwyLjc2MSwxLjFhMS44LDEuOCwwLDAsMS0uNjY5LDMuNDYySDExLjY5MiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMuNzA2IC0yLjk2KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KICAgIDxsaW5lIGlkPSJMaW5lXzEyMzMiIGRhdGEtbmFtZT0iTGluZSAxMjMzIiB5MT0iMS42NzIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkuOTk0IDQuMzA4KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KICAgIDxsaW5lIGlkPSJMaW5lXzEyMzQiIGRhdGEtbmFtZT0iTGluZSAxMjM0IiB5MT0iMS42NzIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkuOTk0IDE0LjAwNykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgICA8cGF0aCBpZD0iUGF0aF81Njk1IiBkYXRhLW5hbWU9IlBhdGggNTY5NSIgZD0iTTEwLjI0Mi43NWE5LjQ5Miw5LjQ5MiwwLDEsMCw5LjQ5Miw5LjQ5MlYuNzUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLjI0OSAtMC4yNDgpIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgWinnings as ReactComponent };